import { render, staticRenderFns } from "./YearAsJapaneseCalendarEditor.vue?vue&type=template&id=e70474a0&scoped=true&"
import script from "./YearAsJapaneseCalendarEditor.vue?vue&type=script&lang=ts&"
export * from "./YearAsJapaneseCalendarEditor.vue?vue&type=script&lang=ts&"
import style0 from "./YearAsJapaneseCalendarEditor.vue?vue&type=style&index=0&id=e70474a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70474a0",
  null
  
)

export default component.exports